import { render, staticRenderFns } from "./ManagePayments.vue?vue&type=template&id=64e5c84f&scoped=true&"
import script from "./ManagePayments.vue?vue&type=script&lang=js&"
export * from "./ManagePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5c84f",
  null
  
)

export default component.exports